import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { Skeleton } from "@mui/material";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";

import PayInModal from "./PayInModal";
import PayOutModal from "./PayOutModal";
import ReactPaginate from "react-paginate";
import { useContextApi } from "../../../context/ContextApi";
import Table from "../../../constants/Table";
import { usePermission } from "../../../context/PermissionContext";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import { useAuth } from "../../../context/AuthProvider";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { AddIcon, MinusIcon, PhoneIcon, ShowIcon, UserIcon, XIcon } from "../../../constants/Icons";
const ViewPaylater = ({ isData, onClose, onDataUpdate,isActive }) => {
  const [isPreLoading, setPreLoading] = useState(true);
  const [isPlaterData, setPlaterData] = useState([]);
  const { storeSettings } = usePermission();
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [isPayInModalOpen, setIsPayInModalOpen] = useState(false);
  const [isPayOutModalOpen, setIsPayOutModalOpen] = useState(false);
  const [isBalance, setBalance] = useState(0);
  const hasFetched = useRef(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
  const { updateSettings } = useAuth();
  const { useEscapeKey } = useContextApi();
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 10;

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const getColor = (status) => {
    if (!status || typeof status !== "string") return "bg-label-secondary";
    switch (status.toLowerCase()) {
      case "payin":
        return "bg-label-plus";
      case "payout":
        return "bg-label-minus";
      case "sale":
        return "bg-label-moon";
      default:
        return "bg-label-secondary";
    }
  };

  const getBgColor = (status) => {
    if (!status || typeof status !== "string") return "bg-label-secondary";
    switch (status.toLowerCase()) {
      case "payin":
        return "bg-label-success";
      case "payout":
        return "bg-label-danger";
      default:
        return "bg-label-secondary";
    }
  };

  const handleClose = () => {
    setIsMainModalOpen(false);
    onClose();
  };
  useEscapeKey(handleClose);
  const handleSaleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
    // navigate(location.pathname, { replace: true, state: {} });
  };

  const handleSaleView = async (item) => {
    if (item.trackmode === "SALE") {
      const data = await handleSaleItems(item.trackid);
      if (data) {
        setViewData(data);
        setViewModalOpen(true);
        setViewTempModalOpen(true);
      }
    }
  };

  const handlePayInModalClose = () => {
    setIsPayInModalOpen(false);
  };

  const handlePayOutModalClose = () => {
    setIsPayOutModalOpen(false);
  };

  const handleMainModalReopen = () => {
    setIsMainModalOpen(true);
  };

  const handlePayIn = () => {
    setIsMainModalOpen(false);
    setIsPayInModalOpen(true);
  };

  const handlePayOut = () => {
    setIsMainModalOpen(false);
    setIsPayOutModalOpen(true);
  };

  const handlePlaterList = async (page = 0) => {
    setPreLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = { customerid: isData.customerid };
      const response = await AxiosInstance.get(
        `module/paylater/${isData.customerid}?pageno=${
          page + 1
        }&limit=${perPage}`,
      );

      const results = response.data.results;
      if (response.data.currentPage === 1)
        setBalance(results[0]?.closeamount || 0);
      else setBalance(isBalance || 0);

      setPlaterData(results || []);
      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(1);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
        setCurrentPage(response.data.currentPage);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
    }
  };

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      const results = response.data.results;
      return results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateIdtemplateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewTempModalOpen(false);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handlePayInf = async (
    customerid,
    amount,
    description,
    paymode,
    paymentmode,
    handleClose,
  ) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const formattedAmount = parseFloat(amount).toFixed(2);
      const data = {
        customerid: customerid,
        amount: CurrencyConverter.toSubunit(formattedAmount, "INR"),
        description: description,
        paymode: paymode,
        paymentmode: paymentmode,
      };
      const response = await AxiosInstance.post(`module/paylater`, data);

      const result = response?.data?.results;
      setPlaterData((prev) => [result, ...prev.slice(0, 9)]);
      setBalance(result.closeamount || 0);
      showAlert("success", Messages.SUCCESS.PAYLATER_ADDED);
      onDataUpdate();
      // handlePlaterList();
      handleClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const formatTrackMode = (trackmode) => {
    switch (trackmode?.toUpperCase()) {
      case "PAYIN":
        return "PAY IN";
      case "PAYOUT":
        return "PAY OUT";
      case "SALE":
        return (
          <div className="d-flex align-items-center">
            SALE <ShowIcon iClass={"fs-14 me-1"}/>
          </div>
        );
      default:
        return trackmode;
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    setBalance(isData?.paylaterBalance || 0);
    handlePlaterList();

    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  if (!isMainModalOpen && !isPayInModalOpen && !isPayOutModalOpen) return null;

  return (
    <>
      {isMainModalOpen && (
        <div>
          <div className="modal-backdrop show"></div>
          <div
            className="modal show"
            id="PaylaterView"
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-scrollable modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  {/* <h6 className="modal-title">Transactions</h6> */}
                  <div className="d-flex align-items-center text-center modal-title pe-3">
                    Transactions{" "}
                    {isData?.name && (
                      <>
                        -{" "}
                        <span className="d-flex align-items-center justify-content-between badge rounded-pill bg-label-secondary cursor-poInter ">
                          <span className="me-2">
                            <UserIcon iClass={"fs-6"}/>
                          </span>
                          <span className="me-1">{isData?.name}</span>
                        </span>
                      </>
                    )}
                    {isData?.phone && (
                      <>
                        -{" "}
                        <span className="d-flex align-items-center justify-content-between badge rounded-pill bg-label-secondary cursor-poInter ">
                          <span className="me-2">
                            <PhoneIcon iClass={"fs-6"}/>
                          </span>
                          <span className="me-1">{isData?.phone}</span>
                        </span>
                      </>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={handleClose}
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body p-0">
                  <div className="container py-2">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
                      <div className="col-xl-5 col-lg-5 col-md-10 d-flex p-0 mx-auto">
                        <div className="card flex-fill shadow-none p-0 mb-0">
                          <div className="card-body p-0">
                            <div className="border rounded p-1 mb-0">
                              <div className="row g-2 align-items-center">
                                <div className="col-12 col-md-4 d-flex justify-content-center">
                                  <div className="text-center flex-fill">
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={handlePayOut}
                                    >
                                      <MinusIcon/>Pay Out
                                    </button>
                                  </div>
                                </div>

                                <div
                                  className={`col-12 col-md-4 d-flex py-1 border-0 radius-8 text-center ${getBgColor(
                                    isBalance >= 0 ? "PAYIN" : "PAYOUT",
                                  )}`}
                                >
                                  <div className="text-center flex-fill mx-auto">
                                    {isPreLoading ? (
                                      <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={13}
                                        className="radius-5 bg-light-grey"
                                      />
                                    ) : (
                                      (() => {
                                        return (
                                          <>
                                            <h4
                                              className={`mb-0 me-2 ${
                                                isBalance >= 0
                                                  ? "text-success"
                                                  : "text-danger"
                                              }`}
                                            >
                                              {CurrencyConverter.toCurrency(
                                                isBalance,
                                                "INR",
                                              )}
                                            </h4>
                                            <p
                                              className={`fs-13 mb-0 fw-medium ${
                                                isBalance >= 0
                                                  ? "text-success"
                                                  : "text-danger"
                                              }`}
                                            >
                                              Total Balance
                                            </p>
                                          </>
                                        );
                                      })()
                                    )}
                                  </div>
                                </div>

                                <div className="col-12 col-md-4 d-flex justify-content-center">
                                  <div className="text-center flex-fill">
                                    <button
                                      className="btn btn-sm btn-success"
                                      onClick={handlePayIn}
                                    >
                                      <AddIcon/> Pay
                                      In
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Table
                    loading={isPreLoading}
                    data={isPlaterData}
                    onRowClick={(item) =>
                      item.trackmode && handleSaleView(item)
                    }
                    columns={[
                      {
                        label: "Created On",
                        render: (item) => (
                          <>
                            {
                              DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  item.createdAt,
                                  "Asia/Kolkata",
                                ),
                              ).date
                            }
                            ,{" "}
                            {
                              DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  item.createdAt,
                                  "Asia/Kolkata",
                                ),
                              ).time
                            }
                          </>
                        ),
                      },
                      {
                        label: "Mode",
                        render: (item) => (
                          <span className="text-heading fw-medium">
                            {item.trackmode && (
                              <span
                                className={`cursor-poInter badge rounded-pill ${getColor(
                                  item.trackmode,
                                )}`}
                                onClick={() => handleSaleView(item)}
                              >
                                {formatTrackMode(item.trackmode)}
                              </span>
                            )}
                          </span>
                        ),
                      },
                      {
                        label: "Description",
                        render: (item) => (
                          <span className="text-wrap">
                            <small>
                              {item.description ? `${item.description}` : ""}
                            </small>
                          </span>
                        ),
                      },
                      {
                        label: "Amount(₹)",
                        render: (item) => (
                          <span className="fw-medium">
                            {item.paymode === "PAYIN" ? (
                              <span className="text-plus">
                                +
                                {formatCurrencyFun(item.amount)}
                              </span>
                            ) : item.paymode === "PAYOUT" ? (
                              <span className="text-minus">
                                -
                                {formatCurrencyFun(item.amount)}
                              </span>
                            ) : (
                              <span className="text-plus">
                                +
                                {formatCurrencyFun(item.amount)}
                              </span>
                            )}
                          </span>
                        ),
                      },
                      {
                        label: "Closing Balance(₹)",
                        render: (item) => (
                          <span className="fw-medium">
                            {formatCurrencyFun(item.closeamount)}
                          </span>
                        ),
                      },
                    ]}
                  />

                  {totalPages > 0 && (
                    <div className="d-flex justify-content-center mt-3">
                      <ReactPaginate
                        previousLabel={"← Previous"}
                        nextLabel={"Next →"}
                        breakLabel={"..."}
                        onPageChange={({ selected }) =>
                          handlePlaterList(selected, perPage)
                        }
                        forcePage={currentPage - 1}
                        pageRangeDisplayed={5}
                        pageCount={totalPages}
                        containerClassName="pagination"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        activeClassName="active"
                      />
                    </div>
                  )}
                </div>
                <div className="modal-footer d-block">
                  <button
                    onClick={handleClose}
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-outline-secondary text-left"
                  >
                    <XIcon/> Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <PayInModal
        isOpen={isPayInModalOpen}
        onClose={handlePayInModalClose}
        isSelectedData={isData}
        onMainModalReopen={handleMainModalReopen}
        onDataUpdate={onDataUpdate}
        onTransactionUpdate={handlePayInf}
        loading={isBtnLoading}
      />

      <PayOutModal
        isOpen={isPayOutModalOpen}
        onClose={handlePayOutModalClose}
        isSelectedData={isData}
        onMainModalReopen={handleMainModalReopen}
        onDataUpdate={onDataUpdate}
        onTransactionUpdate={handlePayInf}
        loading={isBtnLoading}
      />

      {!templateId && isViewTempModalOpen && (
        <InvoiceTempPreview
          isData={isViewData}
          onClose={() => setViewTempModalOpen(false)}
          onAdd={handleSetTemplate}
        />
      )}
      {templateId && isViewModalOpen && (
       <TemplateModalLayout
          isOpen={isViewModalOpen}
          isData={isViewData}
          onClose={handleSaleClose}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          setSaleData={setViewData}
          isActive={isActive}
        />
      )}
    </>
  );
};

export default ViewPaylater;
